import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reportlineitem',
  templateUrl: './reportlineitem.component.html',
  styleUrls: ['./reportlineitem.component.css']
})
export class ReportlineitemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/myreports/reportlineitem/reportlineitem.component.ts